import React, { useMemo, useState } from 'react';
import { UserAttributeEditor } from '../user/UserAttributeEditor';

export const ProfileForm = ({ initialData = {}, onSubmit }) => {
  const [email, setEmail] = useState(initialData.email ?? "");

  const initialAttrValues = useMemo(() => {
    const map = {};
    if (Array.isArray(initialData.attributes)) {
      initialData.attributes.forEach(attr => {
        map[attr.key] = attr.value;
      });
    }
    return map;
  }, [initialData.attributes]);

  const [attributeValues, setAttributeValues] = useState(initialAttrValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Filter out null values only if they were never set (not in initialData)
    // This allows saving false values for boolean attributes
    const attributesToSubmit = Object.entries(attributeValues)
      .filter(([key, value]) => value !== null || initialData.attributes?.some(a => a.key === key))
      .map(([key, value]) => ({ key, value }));
    
    onSubmit?.({
      email,
      attributes: attributesToSubmit,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="email">Email address</label>
        <input
          type="email"
          className="form-control"
          id="email"
          placeholder="name@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        {/* DYNAMIC USER ATTRIBUTES */}
        <UserAttributeEditor
          initialValues={attributeValues}
          onChange={setAttributeValues}
          onlyEditable
          title="Your Preferences"
        />
      </div>

      <div className="form-group">
        <button className="form-control btn btn-primary" type="submit">
          Submit
        </button>
      </div>
    </form>
  );
};

export default ProfileForm;
